import {
  UseQuizControllerProps,
  useQuizController,
} from './hooks/use-quiz-controller';
import { QuizProvider } from './quiz-provider';
import { QuizDisplay, QuizDisplayProps } from './quiz-display';

export type QuizProps = UseQuizControllerProps & QuizDisplayProps;

export function Quiz({
  reference,
  displayIndex,
  displayRandom,
  requireConfirm,
  onActivitiesLoad,
  onActivitySelect,
  onQuizLoad,
  onDisplayQuestion,
  onAttemptCreated,
  onStart,
  onCancel,
  onAnswer,
  onTimeUp,
  onFinish,
  onSubmitSuccess,
  onSubmitError,
  children,
  ...others
}: QuizProps) {
  const controller = useQuizController({
    reference,
    displayIndex,
    displayRandom,
    requireConfirm,
    onActivitiesLoad,
    onActivitySelect,
    onQuizLoad,
    onDisplayQuestion,
    onAttemptCreated,
    onStart,
    onCancel,
    onAnswer,
    onTimeUp,
    onFinish,
    onSubmitSuccess,
    onSubmitError,
  });

  return (
    <QuizProvider controller={controller}>
      {children || <QuizDisplay {...others} />}
    </QuizProvider>
  );
}

Quiz.displayName = 'Quiz';
